import contentRequest from '~/src/api/requests/contentRequest';

export const getBanners = (domainCity, isAuth = false, tag) => {
    return  contentRequest.getWithCache(
        `${domainCity}/v2/banner-city/search?expand=bannerInfo.tags,order&filter[tags]=${tag}&filter${isAuth ? '[available_auth]=1' : '[available_new]=1'}`
    );
};
